import Api from './api'

// ── Available Plans ──

export const getAvailablePlans = async () => {
  try {
    const result = await Api.get('/saas-proxy/subscription/available-plans')
    return result
  } catch (err) {
    console.error('getAvailablePlans error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar planos'] } }
  }
}

// ── Subscription Status ──

export const getSubscriptionStatus = async () => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/status`)
    return result
  } catch (err) {
    console.error('getSubscriptionStatus error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar status da assinatura'] } }
  }
}

// ── Cancel Subscription ──

export const cancelSubscription = async (hirerId, atPeriodEnd = true) => {
  try {
    const result = await Api.post(`/saas-proxy/subscription/cancel`, { hirerId, atPeriodEnd })
    return result
  } catch (err) {
    console.error('cancelSubscription error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao cancelar assinatura'] } }
  }
}

// ── Plan Change Preview ──

export const getPlanChangePreview = async (hirerId, planPeriodicityId) => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/plan-preview/${planPeriodicityId}`)
    return result
  } catch (err) {
    console.error('getPlanChangePreview error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar preview do plano'] } }
  }
}

// ── Contract Products ──

export const getContractProducts = async () => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/products`)
    return result
  } catch (err) {
    console.error('getContractProducts error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar produtos contratados'] } }
  }
}

export const addProductToContract = async (hirerId, applicationId, planPeriodicityId) => {
  try {
    const result = await Api.post(`/saas-proxy/subscription/products`, { applicationId, planPeriodicityId })
    return result
  } catch (err) {
    console.error('addProductToContract error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao adicionar produto'] } }
  }
}

export const getAvailableProducts = async () => {
  try {
    const result = await Api.get('/saas-proxy/subscription/available-products')
    return result
  } catch (err) {
    console.error('getAvailableProducts error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar produtos disponíveis'] } }
  }
}

export const getPlanPeriodicities = async (applicationId, planId) => {
  try {
    const params = []
    if (applicationId) params.push(`applicationId=${applicationId}`)
    if (planId) params.push(`planId=${planId}`)
    const query = params.length > 0 ? `?${params.join('&')}` : ''
    const result = await Api.get(`/saas-proxy/subscription/plan-periodicities${query}`)
    return result
  } catch (err) {
    console.error('getPlanPeriodicities error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar periodicidades'] } }
  }
}

// ── Change Plan ──

export const changePlan = async (hirerId, oldPlanPeriodicityId, newPlanPeriodicityId) => {
  try {
    const result = await Api.post(`/saas-proxy/subscription/change-plan`, { hirerId, oldPlanPeriodicityId, newPlanPeriodicityId })
    return result
  } catch (err) {
    console.error('changePlan error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao trocar plano'] } }
  }
}

export const cancelProducts = async (hirerId, planPeriodicityIds) => {
  try {
    const result = await Api.post(`/saas-proxy/subscription/cancel-products`, { hirerId, planPeriodicityIds })
    return result
  } catch (err) {
    console.error('cancelProducts error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao cancelar produtos'] } }
  }
}

// ── Reactivate Subscription ──

export const reactivateSubscription = async (hirerId, planPeriodicityIds) => {
  try {
    const result = await Api.post(`/saas-proxy/subscription/reactivate`, { hirerId, planPeriodicityIds })
    return result
  } catch (err) {
    console.error('reactivateSubscription error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao reativar assinatura'] } }
  }
}

export const getCanceledProducts = async () => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/canceled-products`)
    return result
  } catch (err) {
    console.error('getCanceledProducts error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar produtos cancelados'] } }
  }
}

// ── Usage ──

export const getSubscriptionUsage = async () => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/usage`)
    return result
  } catch (err) {
    console.error('getSubscriptionUsage error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar uso'] } }
  }
}

// ── Plan Features ──

export const getPlanFeatures = async () => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/plan-features`)
    return result
  } catch (err) {
    console.error('getPlanFeatures error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar features'] } }
  }
}

// ── Checkout Session ──

export const createCheckoutSession = async (hirerId, products, successUrl, cancelUrl) => {
  try {
    const result = await Api.post(`/saas-proxy/checkout/session`, {
      hirerId,
      products,
      successUrl,
      cancelUrl
    })
    return result
  } catch (err) {
    console.error('createCheckoutSession error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao criar sessão de checkout'] } }
  }
}

// ── Subscribe (direct, no redirect) ──

export const subscribe = async (hirerId, products, paymentMethodId = null) => {
  try {
    const result = await Api.post(`/saas-proxy/subscription/subscribe`, {
      hirerId,
      products,
      paymentMethodId
    })
    return result
  } catch (err) {
    console.error('subscribe error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao criar assinatura'] } }
  }
}

// Polling do status da provisioning queue (modal Assinar Agora apos submit).
// Retorna { id, status, currentStep, totalSteps, errorMessage, failedStep }.
export const getProvisioningStatus = async (queueId) => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/provisioning-status/${queueId}`)
    return result
  } catch (err) {
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao consultar status'] } }
  }
}

// ── Credits ──

export const getCreditBalances = async () => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/credits/balances`)
    return result
  } catch (err) {
    console.error('getCreditBalances error:', err)
    return { data: { success: false, data: [] } }
  }
}

export const getCreditTransactions = async (hirerId, creditBalanceId) => {
  try {
    let url = `/saas-proxy/subscription/credits/transactions`
    if (creditBalanceId) url += `?creditBalanceId=${creditBalanceId}`
    const result = await Api.get(url)
    return result
  } catch (err) {
    console.error('getCreditTransactions error:', err)
    return { data: { success: false, data: [] } }
  }
}

export const purchaseCredits = async (hirerId, contractPlanPeriodicityId, amount, paymentMethodId) => {
  try {
    const result = await Api.post(`/saas-proxy/subscription/credits/purchase`, { hirerId, contractPlanPeriodicityId, amount, paymentMethodId })
    return result
  } catch (err) {
    console.error('purchaseCredits error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao comprar créditos'] } }
  }
}

export const getCreditPaymentMethods = async (contractPlanPeriodicityId) => {
  try {
    const result = await Api.get(`/saas-proxy/subscription/credits/payment-methods/${contractPlanPeriodicityId}`)
    return result
  } catch (err) {
    return { data: { success: false, data: [] } }
  }
}

export const updateCreditSettings = async (hirerId, contractPlanPeriodicityId, alertThreshold, autoRechargeEnabled, autoRechargeAmount, autoRechargeTrigger) => {
  try {
    const result = await Api.post(`/saas-proxy/subscription/credits/settings`, { hirerId, contractPlanPeriodicityId, alertThreshold, autoRechargeEnabled, autoRechargeAmount, autoRechargeTrigger })
    return result
  } catch (err) {
    console.error('updateCreditSettings error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao atualizar configurações'] } }
  }
}
